<div class="container">
    <div class="text-center">
        <h5 class="mb-2 mt-2 text-primary-dark">Component scores</h5>
    </div>
    
    <div class="">
        <div class="row align-items-center">
            <div *ngFor="let metric of metrics" class="col-4 text-center">
                <div class="align-items-center">
                    <p class="fw-bold mb-2 me-2 text-primary-dark">{{ metric.score }}%</p>
    
                    <div class="progress-bar-container mb-3 ms-5">
                        <div class="progress-bar bg-primary" [style.height]="metric.score + '%'" style="width: 100%;"></div>
                    </div>
    
                </div>
                
                <p class="text-center fw-bold">{{ metric.name }}</p>
            </div>
        </div>
    </div>
</div>
